/**
 * Postcode -> depot lookup.
 *
 * Match order (same as blfuels.co.uk):
 *   1. format validation
 *   2. full-postcode exceptions   e.g. ab544te -> Gamrie
 *   3. restricted outward codes   e.g. iv27 -> Invergordon, but "please call us"
 *   4. outward code               e.g. ab41
 *   5. sector / sub-area          e.g. "ab52 6"
 */
(function () {
  'use strict';

  // UK postcode format, tested against the space-stripped input.
  var VALID_POSTCODE = /^[A-Z]{1,2}[0-9R][0-9A-Z]?[0-9][ABD-HJLNP-UW-Z]{2}$/i;

  function PostcodeLookup(data) {
    data = data || {};
    this.depots = data.depots || {};
    this.restricted = data.restricted || {};
    this.exceptions = data.exceptions || {};
  }

  /** "AB12 3CD" -> "ab123cd" */
  PostcodeLookup.prototype.normalize = function (postcode) {
    return String(postcode == null ? '' : postcode).toLowerCase().replace(/\s+/g, '');
  };

  /** "AB12 3CD" -> "ab12" */
  PostcodeLookup.prototype.outwardCode = function (postcode) {
    return this.normalize(postcode).slice(0, -3);
  };

  /** "AB52 6CD" -> "ab52 6" */
  PostcodeLookup.prototype.sectorCode = function (postcode) {
    var raw = this.normalize(postcode);
    return raw.slice(0, -3) + ' ' + raw.slice(-3, -2);
  };

  PostcodeLookup.prototype.isValidFormat = function (postcode) {
    return VALID_POSTCODE.test(this.normalize(postcode));
  };

  /** Depot names, in the order they appear in the data file. */
  PostcodeLookup.prototype.depotNames = function () {
    return Object.keys(this.depots);
  };

  /**
   * Returns { status, depot, message }
   *   status 'invalid'    - not a recognisable UK postcode
   *   status 'ok'         - we deliver, depot is set
   *   status 'restricted' - we deliver to parts of it only; depot is set, message explains
   *   status 'none'       - valid postcode, outside all delivery areas
   */
  PostcodeLookup.prototype.lookup = function (postcode) {
    var raw = this.normalize(postcode);

    if (!VALID_POSTCODE.test(raw)) {
      return { status: 'invalid', depot: null, message: null };
    }

    if (Object.prototype.hasOwnProperty.call(this.exceptions, raw)) {
      return { status: 'ok', depot: this.exceptions[raw], message: null };
    }

    var outward = raw.slice(0, -3);

    if (Object.prototype.hasOwnProperty.call(this.restricted, outward)) {
      var rule = this.restricted[outward];
      return { status: 'restricted', depot: rule.depot || null, message: rule.message || null };
    }

    var names = this.depotNames();
    var i;

    for (i = 0; i < names.length; i++) {
      if ((this.depots[names[i]].postcodes || []).indexOf(outward) > -1) {
        return { status: 'ok', depot: names[i], message: null };
      }
    }

    var sector = outward + ' ' + raw.slice(-3, -2);

    for (i = 0; i < names.length; i++) {
      if ((this.depots[names[i]].sub_areas || []).indexOf(sector) > -1) {
        return { status: 'ok', depot: names[i], message: null };
      }
    }

    return { status: 'none', depot: null, message: null };
  };

  /** Convenience: depot name, or null if we don't deliver / input is bad. */
  PostcodeLookup.prototype.findDepot = function (postcode) {
    var result = this.lookup(postcode);
    return result.status === 'ok' || result.status === 'restricted' ? result.depot : null;
  };

  window.PostcodeLookup = PostcodeLookup;
})();
